interface ScribPostLogoProps {
  size?: "sm" | "md" | "lg";
  compact?: boolean;
}

function ScribDoodleIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M4.5 3.2 L17.3 2.8 L22.8 8.5 L22.5 27.8 L4.8 28.2 Z"
        fill="hsl(188 90% 42%)"
        fillOpacity="0.13"
        stroke="hsl(188 90% 42%)"
        strokeWidth="1.4"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <path
        d="M17.3 2.8 L17.1 8.8 L22.8 8.5"
        fill="hsl(188 90% 42%)"
        fillOpacity="0.28"
        stroke="hsl(188 90% 42%)"
        strokeWidth="1.4"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <path
        d="M7.5 13.0 C8.2 12.5 9.1 13.3 10.0 12.8 C10.9 12.3 11.8 13.1 12.7 12.7 C13.5 12.3 14.2 13.0 15.0 12.6 C15.7 12.2 16.3 12.9 17.0 12.6"
        stroke="hsl(188 90% 42%)"
        strokeWidth="1.6"
        strokeLinecap="round"
        fill="none"
        opacity="0.85"
      />
      <path
        d="M7.8 16.5 C8.6 15.9 9.7 16.7 10.7 16.1 C11.7 15.5 12.5 16.4 13.5 15.9 C14.4 15.5 15.3 16.3 16.2 15.8 C17.0 15.4 17.8 16.1 18.5 15.7"
        stroke="hsl(188 90% 42%)"
        strokeWidth="1.6"
        strokeLinecap="round"
        fill="none"
        opacity="0.85"
      />
      <path
        d="M7.8 19.9 C8.7 19.3 9.7 20.1 10.6 19.6 C11.4 19.2 12.3 19.8 13.2 19.4 C13.9 19.1 14.5 19.7 15.2 19.4"
        stroke="hsl(188 90% 42%)"
        strokeWidth="1.6"
        strokeLinecap="round"
        fill="none"
        opacity="0.65"
      />
      <path
        d="M7.9 23.1 C8.5 22.8 9.2 23.3 9.8 23.0 C10.4 22.7 10.9 23.2 11.5 22.9"
        stroke="hsl(188 90% 42%)"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
        opacity="0.45"
      />
      <path
        d="M18.5 26.5 L27.2 17.8 L29.5 20.1 L20.8 28.8 Z"
        fill="hsl(188 90% 42%)"
        opacity="0.85"
        stroke="hsl(188 90% 42%)"
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
      <path
        d="M27.2 17.8 L29.0 16.0 L30.5 17.5 L29.5 20.1 Z"
        fill="hsl(188 85% 36%)"
        opacity="0.95"
      />
      <path
        d="M18.5 26.5 L20.8 28.8 L19.0 29.5 Z"
        fill="hsl(188 90% 42%)"
        opacity="1"
      />
    </svg>
  );
}

const sizeMap = {
  sm: { icon: "w-7 h-7 shrink-0", text: "text-base leading-none" },
  md: { icon: "w-8 h-8 shrink-0", text: "text-xl leading-none" },
  lg: { icon: "w-10 h-10 shrink-0", text: "text-2xl leading-none" },
};

export function ScribPostLogo({ size = "md", compact = false }: ScribPostLogoProps) {
  const s = sizeMap[size];

  return (
    <div className="flex items-center gap-1.5">
      <ScribDoodleIcon className={s.icon} />
      {!compact && (
        <span className={`font-display font-bold tracking-tight ${s.text}`}>
          Scrib<span className="text-primary text-glow">Post</span>
        </span>
      )}
    </div>
  );
}

export { ScribDoodleIcon };
